import { styled } from "@mui/material/styles";
import Button from "../Button/Button";

export const StyledMenuButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== "isBadgeInvisible" && prop !== "isActive",
})<{
  isBadgeInvisible?: boolean;
  isActive?: boolean;
}>`
  ${({ startIcon, theme, isBadgeInvisible }) =>
    (Boolean(startIcon) || !isBadgeInvisible) &&
    `&.MuiButtonBase-root {
      min-width: 0;
      padding-left: ${theme.wsc.spacing[1]};
      padding-right: ${theme.wsc.spacing[1]};

      & > .MuiButton-startIcon { margin-right: auto; }
      & > .MuiButton-endIcon   { margin-left:  auto; }
    }`}

  ${({ isActive, theme }) =>
    isActive &&
    `&&& {
      color: ${theme.wsc.palette.primary[500]};
    }`}
`;

export const CustomHeaderStyled = styled("div")`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.wsc.spacing[1]};

  && > .MuiDivider-root {
    margin-right: ${({ theme }) => theme.wsc.spacing[1]};
    margin-left: ${({ theme }) => theme.wsc.spacing[1]};
  }
`;
